import { PlatformRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { GlobalConfigManager } from '../config';
import { Config } from '../config/config.model';

export async function resolveConfig(configPath: string): Promise<PlatformRef> {
  try {
    const config = await loadConfig(configPath);
    GlobalConfigManager.tryCreateInstance(config);

    return platformBrowserDynamic();
  } catch (error) {
    console.error('Failed to load configuration:', error);
    showConfigErrorPage(configPath, error as Error);
    throw error;
  }
}

async function loadConfig(configPath: string): Promise<Config> {
  const currentDate = new Date();
  const url = `${configPath}?ts=${currentDate.getTime()}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to load config from ${configPath}: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

function showConfigErrorPage(configPath: string, error: Error): void {
  document.body.innerHTML = `
      <div style="text-align: center; padding: 50px; font-family: sans-serif;">
      <h1 style="color: red;">Configuration Error</h1>
      <p>Failed to load: <code>${configPath}</code></p>
      <p style="color: gray;">${error.message || 'Unknown error'}</p>
      <button onclick="location.reload()">Retry</button>
    </div>
  `;
}
